import React from 'react'

import { useDispatch, useSelector } from 'react-redux';
import {
  addServiceToCart,
  removeServiceFromCart,
  increaseQuantity,
  decreaseQuantity,
} from '../../redux/cartSlice';

const OurPriceServiceCard = ({e, i, setView, view}) => {


      const dispatch = useDispatch();
  const cartItem = useSelector(state =>
    state.cart.services.find(item => item._id === e._id)
  );

  const handleAdd = () => {
    dispatch(addServiceToCart(e));
  };
    
    
  return (
    <div>
        
        <div className="our-price-list-price-col">
                      <div className="our-price-list-price-col-head">
                        <div className="our-price-list-price-col-head-details">
                          <div className="our-price-list-price-head">
                            <div className="our-price-list-price-heading">
                              {e.heading}
                            </div>
                            <div className="our-price-list-price-price">
                              <s>
                                {e.mainPrice ? (
                                  <>&nbsp;₹ {e.mainPrice}&nbsp;</>
                                ) : (
                                  ""
                                )}
                              </s>{" "}
                              ₹ {e.discountedPrice}
                            </div>
                          </div>

                          <div className="our-price-list-price-text">
                            {e.description}&nbsp;
                            
                            {/* <a href="#book-now">Book</a> */}
                                                        {/* <a >Add</a> */}


{!cartItem?
                            <a onClick={handleAdd}>Add</a>
           :                 
                            <div className="our-price-list-price-options">
                              <div>
                                <i  onClick={() => dispatch(decreaseQuantity(e._id))} class="fa-solid fa-minus"></i>
                                <span>{cartItem.quantity}</span>
                                <i  onClick={() => dispatch(increaseQuantity(e._id))} class="fa-solid fa-plus"></i>
                              </div>
                              <i  onClick={() => dispatch(removeServiceFromCart(e._id))} class="fa-solid fa-trash-can"></i>
                            </div>
}

                            {/* <Link to={`https://wa.me/+919220407009?text=Hello ! I'm Interested in RepairBuddy ${e.AC_Type} ${e.heading}. Please contact me.`} target="blank">Book</Link> */}
                          </div>
                        </div>

                        <div className="our-price-list-price-col-head-button">
                          {view === i ? (
                            <i
                              class="fa-solid fa-angle-up"
                              onClick={() => setView(null)}
                            ></i>
                          ) : (
                            <i
                              class="fa-solid fa-angle-down"
                              onClick={() => setView(i)}
                            ></i>
                          )}
                        </div>
                      </div>

                      {view === i ? (
                        <div className="our-price-list-price-col-content">
                          {e.sericeList.map((e) => (
                            <div className="our-price-list-price-col-list">
                              <i class="fa-solid fa-circle-check"></i>
                              {e}
                            </div>
                          ))}

                          {e.exclusions &&
                            e.exclusions.map((e) => (
                              <div className="our-price-list-price-col-list">
                                <i class="fa-solid fa-circle-xmark"></i>
                                {e}
                              </div>
                            ))}

                          <div className="our-price-list-price-col-need-heading">
                            What we need from you
                          </div>

                          <div className="our-price-list-price-col-need">
                            <div>
                              <svg
                                xmlns="http://www.w3.org/1999/xlink"
                                fill="#000000"
                                height="800px"
                                width="800px"
                                version="1.1"
                                id="Capa_1"
                                viewBox="0 0 308.069 308.069"
                                xml="preserve"
                              >
                                <path d="M307.701,287.76L219.349,15.677c-0.021-0.066-0.051-0.128-0.074-0.193c-0.046-0.128-0.093-0.256-0.146-0.381  c-0.048-0.114-0.099-0.226-0.152-0.337c-0.05-0.104-0.101-0.208-0.156-0.31c-0.064-0.12-0.132-0.237-0.202-0.353  c-0.054-0.089-0.11-0.177-0.168-0.264c-0.077-0.116-0.157-0.23-0.241-0.341c-0.063-0.084-0.128-0.167-0.195-0.248  c-0.084-0.103-0.17-0.203-0.259-0.301c-0.078-0.086-0.159-0.17-0.241-0.253c-0.084-0.084-0.17-0.167-0.258-0.247  c-0.096-0.087-0.195-0.172-0.295-0.254c-0.083-0.068-0.167-0.134-0.253-0.198c-0.11-0.083-0.223-0.162-0.338-0.239  c-0.087-0.058-0.175-0.114-0.264-0.168c-0.116-0.07-0.234-0.138-0.355-0.203c-0.101-0.054-0.204-0.105-0.307-0.154  c-0.112-0.053-0.225-0.106-0.341-0.154c-0.122-0.051-0.247-0.097-0.372-0.142c-0.068-0.024-0.132-0.054-0.201-0.077  c-0.039-0.013-0.078-0.02-0.117-0.032c-0.134-0.041-0.27-0.076-0.407-0.11c-0.106-0.026-0.212-0.054-0.319-0.075  c-0.13-0.026-0.26-0.045-0.392-0.064c-0.116-0.017-0.231-0.036-0.347-0.047c-0.119-0.012-0.239-0.016-0.358-0.022  c-0.129-0.007-0.257-0.014-0.385-0.014c-0.107,0-0.214,0.007-0.322,0.012c-0.141,0.006-0.281,0.012-0.42,0.026  c-0.098,0.01-0.196,0.026-0.294,0.04c-0.148,0.021-0.296,0.043-0.443,0.073c-0.093,0.019-0.185,0.043-0.278,0.066  c-0.149,0.036-0.298,0.074-0.445,0.12c-0.036,0.011-0.071,0.017-0.106,0.029c-0.063,0.021-0.122,0.048-0.184,0.07  c-0.134,0.048-0.267,0.097-0.398,0.152c-0.108,0.045-0.214,0.094-0.319,0.144c-0.111,0.053-0.22,0.107-0.329,0.165  c-0.114,0.061-0.226,0.126-0.336,0.192c-0.095,0.058-0.189,0.117-0.281,0.179c-0.11,0.073-0.218,0.15-0.324,0.229  c-0.09,0.067-0.179,0.137-0.266,0.209c-0.097,0.08-0.192,0.161-0.285,0.245c-0.091,0.082-0.179,0.167-0.266,0.254  c-0.081,0.081-0.159,0.162-0.236,0.246c-0.091,0.099-0.178,0.201-0.263,0.306c-0.065,0.08-0.129,0.161-0.191,0.244  c-0.084,0.113-0.166,0.227-0.244,0.345c-0.057,0.086-0.112,0.172-0.165,0.26c-0.071,0.117-0.139,0.235-0.204,0.356  c-0.054,0.102-0.105,0.204-0.155,0.308c-0.053,0.111-0.105,0.223-0.153,0.338c-0.052,0.125-0.099,0.253-0.145,0.381  c-0.023,0.065-0.052,0.127-0.074,0.194l-6.141,18.912H98.351l4.637-14.279c1.279-3.939-0.877-8.17-4.817-9.45  c-3.939-1.28-8.171,0.877-9.45,4.817L15.452,241.31c-0.007,0.021-0.014,0.042-0.021,0.063L0.369,287.76  c-1.279,3.939,0.877,8.17,4.817,9.45c0.77,0.25,1.55,0.369,2.318,0.369c3.162,0,6.103-2.016,7.132-5.186l13.416-41.313h76.707  c4.142,0,7.5-3.358,7.5-7.5s-3.358-7.5-7.5-7.5H32.922l16.645-51.257c0.67,0.197,1.378,0.307,2.112,0.307h98.379L116.73,287.76  c-1.279,3.939,0.877,8.17,4.817,9.45c0.77,0.25,1.55,0.369,2.318,0.369c3.162,0,6.103-2.016,7.132-5.186l81.218-250.116  l81.219,250.116c1.029,3.17,3.97,5.186,7.132,5.186c0.768,0,1.548-0.119,2.318-0.369C306.823,295.93,308.98,291.699,307.701,287.76z   M54.337,170.129l17.951-55.28h75.522c4.142,0,7.5-3.358,7.5-7.5s-3.358-7.5-7.5-7.5H77.159L93.593,49.24  c0.714,0.226,1.473,0.349,2.261,0.349h98.216l-39.142,120.54H54.337z" />
                              </svg>
                              A Ladder
                            </div>

                            <div>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                height="800px"
                                width="800px"
                                version="1.1"
                                id="_x32_"
                                viewBox="0 0 512 512"
                                xml="preserve"
                              >
                                <g>
                                  <path
                                    class="st0"
                                    d="M453.821,30.5H115.726c-32.116,0-58.248,26.132-58.248,58.179c0,16.343,6.618,31.346,17.891,42.048   l2.463,29.371l1.197,15.078l-0.846-0.991c-22.679,20.148-41.766,42.124-55.572,63.888c-6.83,10.916-12.396,21.764-16.344,32.543   c-3.942,10.778-6.266,21.413-6.266,32.047c-0.069,11.342,2.889,22.96,9.857,32.611c6.906,9.72,17.403,16.695,29.653,20.636   c4.726,1.554,9.513,2.119,14.163,2.119c11.762-0.076,23.243-3.453,35.5-8.454c21.413-8.873,45.289-23.6,70.01-41.21   c30.362-21.688,75.3-60.641,107.767-90.576c-11.405-4.437-20.285-14.019-23.876-25.85c-26.978,25.073-59.444,53.674-82.763,71.702   c-22.397,17.258-44.587,32.542-63.813,43.177c-9.582,5.352-18.386,9.513-25.85,12.189c-7.401,2.744-13.53,3.872-16.976,3.804   c-1.692,0-2.752-0.214-3.171-0.358c-6.831-2.318-10.07-5-12.045-7.745c-1.974-2.82-3.239-6.342-3.239-12.044   c-0.069-5.214,1.197-12.114,4.154-19.934c4.223-11.831,12.044-25.705,22.754-39.868c5.984-7.959,12.884-16.055,20.491-24.02   l1.624,19.088l4.787,56.913l0.633-0.351c9.162-5.069,19.302-11.411,30.218-18.875l-5.703-68.957l-1.196-14.301l-5.427-65.367   h356.619l-22.115,267.171c-2.607,31.064-28.526,54.939-59.727,54.939h-192.93c-31.132,0-57.12-23.875-59.658-54.939L127,361.194   l-1.204-14.294c-11.198,6.48-21.482,11.694-31.201,15.704l0.144,1.273l2.676,32.962c3.942,47.476,44.374,84.661,91.988,84.661   h192.93c47.683,0,88.115-37.186,91.987-84.661l22.26-268.718C506.366,117.555,512,103.612,512,88.679   C512,56.632,485.944,30.5,453.821,30.5z M468.052,110.092H101.356c-6.899-4.65-11.48-12.471-11.48-21.413   c0-14.232,11.549-25.781,25.849-25.781h338.095c14.232,0,25.781,11.55,25.781,25.781   C479.602,97.621,474.952,105.442,468.052,110.092z"
                                  />
                                  <circle
                                    class="st0"
                                    cx="281.788"
                                    cy="180.15"
                                    r="21.131"
                                  />
                                </g>
                              </svg>
                              2 Buckets
                            </div>

                            <div>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="#000000"
                                height="800px"
                                width="800px"
                                version="1.1"
                                id="Layer_1"
                                viewBox="0 0 512 512"
                              >
                                <g>
                                  <g>
                                    <path d="M428.522,0H83.478C37.448,0,0,37.448,0,83.478v345.043C0,474.552,37.448,512,83.478,512h345.043    c46.03,0,83.478-37.448,83.478-83.478V83.478C512,37.448,474.552,0,428.522,0z M478.609,428.522    c0,27.618-22.469,50.087-50.087,50.087H83.478c-27.618,0-50.087-22.469-50.087-50.087V83.478    c0-27.618,22.469-50.087,50.087-50.087h345.043c27.618,0,50.087,22.469,50.087,50.087V428.522z" />
                                  </g>
                                </g>
                                <g>
                                  <g>
                                    <path d="M189.217,205.913c-27.618,0-50.087,22.469-50.087,50.087c0,27.618,22.469,50.087,50.087,50.087    c27.618,0,50.087-22.469,50.087-50.087C239.304,228.382,216.835,205.913,189.217,205.913z M189.217,272.696    c-9.206,0-16.696-7.49-16.696-16.696c0-9.206,7.49-16.696,16.696-16.696s16.696,7.49,16.696,16.696    C205.913,265.206,198.423,272.696,189.217,272.696z" />
                                  </g>
                                </g>
                                <g>
                                  <g>
                                    <path d="M322.783,205.913c-27.618,0-50.087,22.469-50.087,50.087c0,27.618,22.469,50.087,50.087,50.087S372.87,283.618,372.87,256    C372.87,228.382,350.401,205.913,322.783,205.913z M322.783,272.696c-9.206,0-16.696-7.49-16.696-16.696    c0-9.206,7.49-16.696,16.696-16.696c9.206,0,16.696,7.49,16.696,16.696C339.478,265.206,331.989,272.696,322.783,272.696z" />
                                  </g>
                                </g>
                                <g>
                                  <g>
                                    <path d="M256,66.783C151.666,66.783,66.783,151.666,66.783,256S151.666,445.217,256,445.217S445.217,360.334,445.217,256    S360.334,66.783,256,66.783z M256,411.826c-85.922,0-155.826-69.904-155.826-155.826S170.077,100.174,256,100.174    S411.826,170.077,411.826,256S341.923,411.826,256,411.826z" />
                                  </g>
                                </g>
                              </svg>
                              A plug point
                            </div>
                          </div>

                          {/* 
                      <div className="our-price-list-price-col-details-btn">
                        View Details & Spare Parts Rate Card
                      </div> */}
                      
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
        
        
    </div>
  )
}

export default OurPriceServiceCard